// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"381":"fcc6a1f0","388":"845ef3fc"}[chunkId] + ".css";
};